import React from 'react';
import { MenuItemWithAnalytics } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import { isDevelopment } from 'src/services/http/user';
import { ADOPTION_AND_CHANGE_MANAGEMENT_FF, JIRA_HUB_FF } from 'src/constants';

import { withUrlPrefix, LINKS } from './GlobalAppNavigation';

export const AdoptionMobileMenu: React.FC = () => {
  const jiraHubEnabled = (isDevelopment() || FeatureGates.checkGate(JIRA_HUB_FF)) ?? false;
  const adoptionAndChangeManagementEnabled =
    (isDevelopment() || FeatureGates.checkGate(ADOPTION_AND_CHANGE_MANAGEMENT_FF)) ?? false;

  return (
    <ul css={listStyles}>
      {adoptionAndChangeManagementEnabled && (
        <MenuItemWithAnalytics link={withUrlPrefix(LINKS.ADOPTION_AND_CHANGE_MANAGEMENT_GUIDE)} type="subMenu" />
      )}
      <MenuItemWithAnalytics link={withUrlPrefix(LINKS.ROVO_ADOPTION_GUIDE)} type="subMenu" />
      {jiraHubEnabled && (
        <>
          <MenuItemWithAnalytics link={withUrlPrefix(LINKS.JIRA_ADOPTION_GUIDE)} type="subMenu" />
          <MenuItemWithAnalytics link={withUrlPrefix(LINKS.JIRA_CLOUD_ADOPTION_GUIDE)} type="subMenu" />
        </>
      )}
    </ul>
  );
};

const listStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.150'),
  listStyle: 'none',
  margin: 0,
  padding: `${token('space.150')} 0 0 0`,

  '&:hover li': {
    color: token('color.link'),
  },

  li: {
    padding: `${token('space.200')} 0`,
  },
});
